import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["for"]
const _hoisted_2 = { class: "custom-upload-st2" }
const _hoisted_3 = ["id", "accept"]
const _hoisted_4 = { class: "s4 custom-upload-img" }
const _hoisted_5 = { class: "s12" }
const _hoisted_6 = {
  id: "file-upload-title",
  class: "custom-upload-text"
}
const _hoisted_7 = {
  id: "file-upload-title",
  class: "custom-upload-text-sm"
}

import { reactive, ref, onMounted, computed } from "vue";

    
export default /*@__PURE__*/_defineComponent({
  __name: 'OnboardingPayslipUploadInput',
  props: {
        id: { type: String, required: true },
        caption: { type: String, default: '' },
        label: { type: String, default: 'Fichier' },
        required: { type: Boolean, default: false }
    },
  emits: ["uploaded"],
  setup(__props, { emit: __emit }) {


    const emit = __emit
    const props = __props;
    const extensionsAllowed = ['.pdf', '.doc', '.docx', '.xls', '.xlsx'];
    const formValue = reactive({
        file: '',
        file_name: '',
        file_preview: null as any,
    });

    function onFileUploaded(event: any) {
        if (event.target.files.length > 0) {
            var reader = new FileReader();
            reader.onload = function(e) {
                formValue.file = event.target.files[0];
                formValue.file_name = event.target.files[0].name;
                formValue.file_preview = e.target!.result as string;
                emit('uploaded', formValue);
            }
            reader.readAsDataURL(event.target.files[0]);
        }
    }


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", {
    for: props.id,
    class: _normalizeClass(["custom-upload my-5", {'active': formValue.file}])
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("input", {
        id: props.id,
        class: "display-none",
        type: "file",
        ref: "fichier_photo",
        onChange: _cache[0] || (_cache[0] = ($event: any) => (onFileUploaded($event))),
        accept: extensionsAllowed.join(',')
      }, null, 40, _hoisted_3),
      _createElementVNode("div", _hoisted_4, _toDisplayString(props.caption), 1),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("span", _hoisted_6, _toDisplayString(props.label), 1),
        _cache[1] || (_cache[1] = _createElementVNode("b", { class: "color-danger" }, "*", -1)),
        _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)),
        _createElementVNode("span", _hoisted_7, _toDisplayString(formValue.file_name ? formValue.file_name : "Charger le doc"), 1)
      ]),
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "s4 right" }, [
        _createElementVNode("img", {
          src: "/icons/icon-upload.svg",
          class: "custom-upload-icon"
        })
      ], -1))
    ])
  ], 10, _hoisted_1))
}
}

})